import { defineComponent as _defineComponent } from 'vue'
import ColorIcon from '@/ui/components/richText/icons/ColorIcon.vue';
  import ColorIconFocused from '@/ui/components/richText/icons/ColorIconFocused.vue';
  import HighlightIcon from '@/ui/components/richText/icons/HighlightIcon.vue';
  import HighlightIconFocus from '@/ui/components/richText/icons/HighlightIconFocus.vue';
  import LinkPromptModal from '@/ui/components/richText/LinkPromptModal.vue';
  import ToolbarButton from '@/ui/components/richText/ToolbarButton.vue';
  import ToolbarColorButton from '@/ui/components/richText/ToolbarColorButton.vue';
  import ToolbarSeparator from '@/ui/components/richText/ToolbarSeparator.vue';
  import { useModal } from '@/ui/concerns/modals/useModal';
  import { Editor, BubbleMenu } from '@lumiform/tiptap-vue-2';
  import { Props as TippyProps } from 'tippy.js';
  import { onMounted, onBeforeUnmount, ref } from 'vue';
  import { v4 as uuidv4 } from 'uuid';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EditorToolbar',
  props: {
    editor: null
  },
  setup(__props: any) {

const { editor } = __props as {
    editor: Editor;
  };

  

  const pluginKey = uuidv4();
  const [isModalOpen, openModal, closeModal] = useModal();
  const onLinkSubmit = ref<(link: string) => void>(() => {});
  const previousUrl = ref<string | undefined>(undefined);

  const tippyOptions: TippyProps = {
    duration: 100,
    maxWidth: 'none',
    onClickOutside: instance => {
      instance.hide();
    },
  };

  const toolbarIcons = [
    {
      id: 'bold',
      icon: ['far', 'bold'],
      command: () => editor.chain().focus().toggleBold().run(),
    },
    {
      id: 'italic',
      icon: ['far', 'italic'],
      command: () => editor.chain().focus().toggleItalic().run(),
    },
    {
      id: 'underline',
      icon: ['far', 'underline'],
      command: () => editor.chain().focus().toggleUnderline().run(),
    },
    {
      id: 'strike',
      icon: ['far', 'strikethrough'],
      command: () => editor.chain().focus().toggleStrike().run(),
    },
    {
      id: 'orderedList',
      icon: ['far', 'list-ol'],
      command: () => editor.chain().focus().toggleOrderedList().run(),
    },
    {
      id: 'bulletList',
      icon: ['far', 'list-ul'],
      command: () => editor.chain().focus().toggleBulletList().run(),
    },
    {
      id: 'link',
      icon: ['far', 'link'],
      command: () => {
        previousUrl.value = editor.getAttributes('link').href;
        openModal();

        onLinkSubmit.value = (url: string) => {
          if (url === '') {
            editor.chain().focus().extendMarkRange('link').unsetLink().run();
          } else {
            editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
          }

          closeModal();
        };
      },
    },
  ];

  const removeFormattingIcon = {
    id: 'removeFormatting',
    icon: ['far', 'remove-format'],
    command: () => {
      editor.chain().focus().unsetAllMarks().run();
    },
  };

  const setColor = (color: string) => {
    editor.chain().focus().setColor(color).run();
  };

  const setHighlight = (color: string) => {
    editor.chain().focus().setHighlight({ color }).run();
  };

  onMounted(() => {
    editor.on('update', refreshIsActive);
    editor.on('selectionUpdate', refreshIsActive);
  });

  onBeforeUnmount(() => {
    editor.off('update');
    editor.off('selectionUpdate');
  });

  const isActive = ref<Record<string, boolean>>({
    link: false,
    bold: false,
    italic: false,
    strike: false,
    underline: false,
    bulletList: false,
    orderedList: false,
  });

  const dynamicAttributes = ref<Record<string, string|undefined>>({
    color: undefined,
    highlight: undefined,
  });

  const refreshIsActive = () => {
    isActive.value.link = editor.isActive('link');
    isActive.value.bold = editor.isActive('bold');
    isActive.value.italic = editor.isActive('italic');
    isActive.value.strike = editor.isActive('strike');
    isActive.value.underline = editor.isActive('underline');
    isActive.value.bulletList = editor.isActive('bulletList');
    isActive.value.orderedList = editor.isActive('orderedList');

    dynamicAttributes.value!.color = editor.getAttributes('color').color;
    dynamicAttributes.value!.highlight = editor.getAttributes('highlight').color;
  };


return { __sfc: true,pluginKey, isModalOpen, openModal, closeModal, onLinkSubmit, previousUrl, tippyOptions, toolbarIcons, removeFormattingIcon, setColor, setHighlight, isActive, dynamicAttributes, refreshIsActive, ColorIcon, ColorIconFocused, HighlightIcon, HighlightIconFocus, LinkPromptModal, ToolbarButton, ToolbarColorButton, ToolbarSeparator, BubbleMenu }
}

})